import { Box, Link as LinkBase } from "@mui/material";
import CustomTable from "components/Table/CustomTable";
import { TABLE_ACTIONS } from "helpers/constants";
import { FC } from "react";
import ConfirmActionModal from "modals/ConfirmActionModal/ConfirmActionModal";
import { Link, useParams } from "react-router-dom";
import { useClinicText } from "hooks/useClinicText";

type CustomListProps = {
  academicYears: any[];
  handleActionClick: (action: TABLE_ACTIONS, id: string) => void;
  deleteAcademicYearModal: boolean;
  setDeleteAcademicYearModal: (value: boolean) => void;
  handleDelete: () => void;
};

export const CustomList: FC<CustomListProps> = ({
  academicYears,
  handleActionClick,
  deleteAcademicYearModal,
  setDeleteAcademicYearModal,
  handleDelete,
}) => {
  const { organizationId } = useParams();
  const { textYearlyCurriculum } = useClinicText();
  return (
    <Box>
      <CustomTable
        entities={academicYears}
        handleActionClick={handleActionClick}
        fieldToFilter={"name"}
        columns={[
          {
            id: "name",
            label: "Name",
            value: "name",
          },
          {
            id: "academic_year_id",
            value: (row: any) => (
              <LinkBase
                sx={{ cursor: "pointer" }}
                component={Link}
                to={`/organization/${organizationId}/yearly-curriculum/${row.academic_year_id}`}
              >
                View
              </LinkBase>
            ),
          },
          { id: "actions", value: "" },
        ]}
        isSelectable={false}
        allowedMenuItems={[
          TABLE_ACTIONS.VIEW,
          TABLE_ACTIONS.EDIT,
          TABLE_ACTIONS.DELETE,
        ]}
        extraActionItems={[]}
        idColumn={"academic_year_id"}
      />

      {deleteAcademicYearModal && (
        <ConfirmActionModal
          title={"Heads up!"}
          message={`Are you sure you want to delete this ${textYearlyCurriculum}?`}
          show={deleteAcademicYearModal}
          onConfirm={handleDelete}
          onDismiss={() => {
            setDeleteAcademicYearModal(false);
          }}
        />
      )}
    </Box>
  );
};
